import { useQuery } from '@tanstack/react-query';
import { Dialog } from '@/components-new/Dialog/Dialog';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { Loader } from '@/components/Loader/Loader';
import { Notification } from '@/components/Notification/Notification';
import { InvoiceCheckType } from '@/types/invoiceVaultTypes';
import { InstructionRow } from '@/bundle/pages/SecureLinkPage/styles';
import { unmaskInvoiceCheck } from '../../../api/api';
import { DialogButtons } from '@/components-new/Dialog/styles';
import { Mono } from '@/styles/common';

export const UnmaskDetailsModal = ({ check, onClose }: { check: InvoiceCheckType; onClose: () => void }) => {
  const { data, isPending } = useQuery({
    queryKey: ['invoice_vault_unmask', check.id],
    queryFn: () => unmaskInvoiceCheck(check.id),
    gcTime: 0,
    staleTime: 0,
  });

  return (
    <Dialog header={`Verified payout details: ${check.vendor_name}`} isOpen onClose={onClose} width='640px'>
      <Notification variant='info'>
        These details matched the invoice and were entered by the verified vendor. This view is logged in the audit log.
      </Notification>
      {isPending ? (
        <Loader />
      ) : data?.error ? (
        <Notification variant='error'>Could not load the details.</Notification>
      ) : (
        <Box display='flex' flexDirection='column'>
          {data.body.rows.map((row) => (
            <InstructionRow key={row.key}>
              <Typography variant='bodySmall'>{row.label}</Typography>
              <Mono>{row.value}</Mono>
              <span />
            </InstructionRow>
          ))}
          <Typography variant='caption' marginTop='12px'>
            Record hash {data.body.record_hash.slice(0, 16)}… anchored as {data.body.blockchain_id}
          </Typography>
        </Box>
      )}
      <DialogButtons>
        <ButtonNew size='medium' onClick={onClose}>
          Close
        </ButtonNew>
      </DialogButtons>
    </Dialog>
  );
};
